import type { SubToPages_pages as Page } from "./SubToPages";

export function indexPageHeaders(pages: Page[]) {
  let inheritedName = "";
  const headers = new Map<string, { page: Page; partName: string }>();
  for (const page of pages) {
    if (page.partName) inheritedName = page.partName;
    headers.set(page.id, { page, partName: inheritedName });
  }
  return headers;
}
